import React,{useEffect,useId,useRef,useState} from 'react';
import {collection,getDocs} from 'firebase/firestore';
import {db} from '../../Security/firebase-config';
import {hasSetupMap,setupKey} from '../../utils/eventSetup';
import {saveSetupMap} from '../../utils/eventSetupStore';
import {getImprovementNoteMapOptions} from '../../utils/teamPlanning';
import {Pencil} from 'lucide-react';

export default function WorkspaceMapLabel({event,slot,canEdit=false}) {
 const root=useRef(null),trigger=useRef(null),choiceId=useId();
 const [editing,setEditing]=useState(false),[maps,setMaps]=useState([]),[busy,setBusy]=useState(false),[error,setError]=useState('');
 useEffect(()=>{
  if(!editing||busy)return;
  const dismiss=event=>{if(!root.current?.contains(event.target))setEditing(false);};
  document.addEventListener('pointerdown',dismiss);
  return ()=>document.removeEventListener('pointerdown',dismiss);
 },[editing,busy]);
 if(hasSetupMap(slot))return <>{slot.mapName||slot.mapId}</>;
 async function open(){
  if(editing){setEditing(false);return;}
  setMaps([]);setEditing(true);setBusy(true);setError('');
  try{const snap=await getDocs(collection(db,'teams',event.__teamId,'maps'));setMaps(getImprovementNoteMapOptions(snap.docs.map(d=>({...d.data(),id:d.id}))));}
  catch{setError('Maps could not be loaded. Retry selecting the map.');}
  finally{setBusy(false);}
 }
 async function save(map){
  setBusy(true);setError('');
  try{await saveSetupMap({teamId:event.__teamId,key:setupKey(event,slot.id),mapId:map.id,mapName:map.name});setEditing(false);trigger.current?.focus();}
  catch(e){setError(e.message||'The map could not be saved.');}
  finally{setBusy(false);}
 }
 return <span ref={root} className="WorkspaceMapLabel" onKeyDown={event=>{
  if(event.key!=='Escape'||!editing)return;
  event.preventDefault();event.stopPropagation();
  if(!busy){setEditing(false);trigger.current?.focus();}
 }}>
  <button ref={trigger} type="button" className="WorkspaceMapLabel__trigger" disabled={!canEdit||busy} onClick={open}
   aria-expanded={canEdit?editing:undefined} aria-controls={editing?choiceId:undefined}
   title={canEdit?'Choose the event map':'Preparation staff can choose the event map'}>
   Map TBD {canEdit&&<Pencil size={12} aria-hidden="true"/>}
  </button>
  {editing&&<span id={choiceId} className="WorkspaceMapLabel__dropdown" role="group" aria-label="Choose event map">
   {maps.map(map=><button type="button" key={map.id} disabled={busy} onClick={()=>save(map)}>{map.name}</button>)}
   {busy&&<span role="status">{maps.length?'Saving map…':'Loading maps…'}</span>}
   {error&&<span role="alert">{error}</span>}
   {!busy&&!error&&!maps.length&&<span>No maps available.</span>}
  </span>}
 </span>;
}
